import { useRef, useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import readXlsxFile from 'read-excel-file';
//
import './Map.css';
import { data } from '../../dataFile';
import BrownMarker from '../../Assets/Icons/brown.png'
import PinkMarker from '../../Assets/Icons/pink.png'
import RedMarker from '../../Assets/Icons/red.png'

var googleMap = window.google;

function Map() {

  const enableFileInput = false,
    mapElementRef = useRef(null),
    mapRef = useRef(null),
    inputRef = useRef(null),
    timeIntervelRef = useRef(null);

  useEffect(() => {
    enableFileInput && fileInputEventListner()
    if (googleMap) mapInit();
    else timeIntervelRef.current = setInterval(() => {
      clearInterval(timeIntervelRef.current);
      googleMap = window.google;
      mapInit();
    }, 2000)
  }, [])

  const mapInit = () => {
    const mapOptions = {
      center: { lat: 32.791777777777774, lng: 35.53616666666667 },
      zoom: 14,
      gestureHandling: 'greedy',
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DEFAULT,
        position: google.maps.ControlPosition.BOTTOM_LEFT,
      },
    };

    mapRef.current = new googleMap.maps.Map(mapElementRef.current, mapOptions);

    const area = []
    const locations = data

    locations.map((location, i) => {

      const lastKey = Object.keys(location).pop();

      Object.keys(location).map((key) => {

        // CHECK if object property doesn't have location
        if (key.indexOf("Position") < 0) return true

        if (key === lastKey) {
          const { Lat, Lng } = convertDMSToLatLong(location[key], true)
          location["Lat"] = Lat
          location["Lng"] = Lng
        }

        location[key] = convertDMSToLatLong(location[key])

        return key
      })

      area.push(location)

      return location
    })

    drawArea(area);
    displayMarker(area);
    // drawArea(data);
    // displayMarker(data);
    //initAutocomplete();
    new AutocompleteDirectionsHandler(mapRef.current);
    return
  }

  const convertDMSToLatLong = (position, isLatLng = false) => {

    if (position.indexOf("x") > -1) return position

    let latLng = position.replace("/", "").replace(`"N`, "").replace(`"E`, "").split(" "),
      northDMS = latLng[0].replace("'", "°").split("°"),
      eastDMS = latLng[1].replace("'", "°").split("°");

    const lat = parseFloat(northDMS[0]) + ((parseFloat(northDMS[2]) / 60) + parseFloat(northDMS[1])) / 60

    const lng = parseFloat(eastDMS[0]) + ((parseFloat(eastDMS[2]) / 60) + parseFloat(eastDMS[1])) / 60

    return !isLatLng ? `x${lng} y ${lat}` : { Lat: lat, Lng: lng };
  }

  const drawArea = (newData) => {
    newData.map(row => {
      const area = []

      if (row.Position1) area.push(getLatLong(row.Position1))
      if (row.Position2) area.push(getLatLong(row.Position2))
      if (row.Position3) area.push(getLatLong(row.Position3))
      if (row.Position4) area.push(getLatLong(row.Position4))
      if (row.Position5) area.push(getLatLong(row.Position5))
      if (row.Position6) area.push(getLatLong(row.Position6))
      if (row.Position7) area.push(getLatLong(row.Position7))
      if (row.Position8) area.push(getLatLong(row.Position8))
      if (row.Position9) area.push(getLatLong(row.Position9))

      var color = "#974A01"
      if (row.Code === "ב") color = "#974A01"
      else if (row.Code === "ג") color = "#FFA4B3"
      else if (row.Code === "א") color = "#FF0000"

      const bermudaArea = new googleMap.maps.Polygon({
        paths: area,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35,
      });

      bermudaArea.setMap(mapRef.current);
    })
  }

  const getLatLong = (position) => {
    // if position is undefined then return
    if (!position) return
    // if position have "," then replace it with y
    if (position.indexOf(",") > -1) position = position.replace(",", " y")
    // get lat-long using replace x and split "y" 
    position = position.replace("x", "").split(" y ")
    return { lat: parseFloat(position[1]), lng: parseFloat(position[0]) }
  }

  const fileInputEventListner = () => {
    const schema = {
      'Code': {
        prop: 'Code',
      },
      'Lat': {
        prop: 'Lat',
      },
      'Lng': {
        prop: 'Lng',
      },
      "Description": {
        prop: 'Description',
      },
      "Area": {
        prop: 'Area',
      },
      "Link": {
        prop: 'Link',
      },
      "Resion": {
        prop: 'Resion',
      },
      "City Name": {
        prop: "CityName"
      },
      "Position1": {
        prop: "Position1"
      },
      "Position2": {
        prop: "Position2"
      },
      "Position3": {
        prop: "Position3"
      },
      "Position4": {
        prop: "Position4"
      },
      "Position5": {
        prop: "Position5"
      },
      "Position6": {
        prop: "Position6"
      },
      "Position7": {
        prop: "Position7"
      },
      "Position8": {
        prop: "Position8"
      },
      "Position9": {
        prop: "Position9"
      },
    }

    inputRef.current?.addEventListener('change', () => {
      readXlsxFile(inputRef.current?.files[0], { schema }).then(({ rows }) => {
        //console.log("JSON.stringify(rows)")
        console.log(JSON.stringify(rows))
        //displayMarker(rows)
      })
    })
  }

  const displayMarker = (rows = []) => {

    // Create an info window to share between markers.
    const infoWindow = new googleMap.maps.InfoWindow();
    //console.log(rows)
    rows.map((row, i) => {
      i = i + 1
      if (!row.Lng || !row.Lat) return true;

      // Create the markers.
      const marker = new googleMap.maps.Marker({
        position: { lat: parseFloat(row.Lat), lng: parseFloat(row.Lng) },
        map: mapRef.current,
        animation: googleMap.maps.Animation.DROP,
        labelInBackground: false,
        // draggable: true,
        // raiseOnDrag: true,
        label: {
          text: i.toString(),
          fontFamily: 'Roboto, Arial, sans-serif, custom-label-'
        },
      });
      marker.setIcon(BrownMarker)
      if (row.Code === "ב") marker.setIcon(BrownMarker)
      else if (row.Code === "ג") marker.setIcon(PinkMarker)
      else if (row.Code === "א") marker.setIcon(RedMarker)

      // Add a click listener for each marker, and set up the info window.
      // marker.addListener("click", () => {
      //   infoWindow.close();
      //   // infoWindow.setContent(ReactDOMServer.renderToString(infoWindowContent(row, i)));
      //   infoWindow.open(marker.getMap(), marker);
      // });
    });
  }

  const setDirection = (origin, destination, waypoints, color) => {

    var directionsService = new googleMap.maps.DirectionsService(),
      directionsRenderer = new googleMap.maps.DirectionsRenderer();

    directionsRenderer.setMap(mapRef.current);
    directionsRenderer.setPanel(document.getElementById('directionsPanel'));

    var request = {
      origin,
      destination,
      waypoints,
      travelMode: 'DRIVING',
      provideRouteAlternatives: true,
      optimizeWaypoints: true,
    };
    directionsService.route(request, function (response, status) {
      //console.log(response, status)
      if (status == 'OK') {
        //console.log("response ....", response)
        // directionsRenderer.setMap(null);

        directionsRenderer.setOptions({
          polylineOptions: {
            strokeColor: color,
            path: [waypoints[0], waypoints[1]]
          }
        });
        directionsRenderer.setDirections(response);
        directionsRenderer.setMap(mapRef.current);
      }
    });
  }

  return (
    <>
      {enableFileInput && <input type="file" ref={inputRef} id="input" />}
      <div className='map' ref={mapElementRef} />
      <div id="directionsPanel" />
      <div className="directions">
        <div className="input-container">
          <div className='input-wrapper'>
            <label className='label'>בחרו נקודת התחלה</label>
            <input
              id="origin-input"
              className="controls"
              type="text"
              placeholder="Enter an origin location"
            />
          </div>
          <div className='input-wrapper'>
            <label className='label'>בחרו יעד</label>
            <input
              id="destination-input"
              className="controls"
              type="text"
              placeholder="Enter a destination location"
            />
          </div>
          {/* <button type="button" class="btn-submit">Lets Go</button> */}
        </div>
      </div>
    </>
  );
}

export default Map;

function infoWindowContent(row, i) {
  return <div dir='rtl'>
    <h4>{i} - {row.Resion} ({row.CityName})</h4>
    <p>{row.Area}</p>
    <p>{row.Description}</p>
    <a href={row.Link} target="blank">Map View</a>
  </div>
}

class AutocompleteDirectionsHandler {
  map: googleMap.maps.Map;
  originPlaceId: string;
  destinationPlaceId: string;
  travelMode: googleMap.maps.TravelMode;
  directionsService: googleMap.maps.DirectionsService;
  directionsRenderer: googleMap.maps.DirectionsRenderer;

  constructor(map: google.maps.Map) {
    this.map = map;
    this.originPlaceId = "";
    this.destinationPlaceId = "";
    this.travelMode = googleMap.maps.TravelMode.DRIVING;
    this.directionsService = new googleMap.maps.DirectionsService();
    this.directionsRenderer = new googleMap.maps.DirectionsRenderer();
    this.directionsRenderer.setMap(this.map);

    const originInput = document.getElementById(
      "origin-input"
    );
    const destinationInput = document.getElementById(
      "destination-input"
    );


    // Specify just the place data fields that you need.
    const originAutocomplete = new googleMap.maps.places.Autocomplete(
      originInput,
      { fields: ["place_id", "geometry"] }
    );

    // Specify just the place data fields that you need.
    const destinationAutocomplete = new googleMap.maps.places.Autocomplete(
      destinationInput,
      { fields: ["place_id", "geometry"] }
    );



    this.setupPlaceChangedListener(originAutocomplete, "ORIG");
    this.setupPlaceChangedListener(destinationAutocomplete, "DEST");

    //alert(window.innerWidth)
    // if (window.innerWidth < 768) {
    //   this.map.controls[googleMap.maps.ControlPosition.TOP_LEFT].push(originInput);
    //   this.map.controls[googleMap.maps.ControlPosition.TOP_LEFT].push(
    //     destinationInput
    //   );
    // } else {
    //   this.map.controls[googleMap.maps.ControlPosition.TOP_LEFT].push(originInput);
    //   this.map.controls[googleMap.maps.ControlPosition.TOP_LEFT].push(
    //     destinationInput
    //   );
    // }

    //this.map.controls[googleMap.maps.ControlPosition.TOP_LEFT].push(modeSelector);
  }

  setupPlaceChangedListener(
    autocomplete: googleMap.maps.places.Autocomplete,
    mode: string
  ) {
    autocomplete.bindTo("bounds", this.map);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.place_id) {
        window.alert("Please select an option from the dropdown list.");
        return;
      }

      //console.log(place);

      if (mode === "ORIG") {
        this.originPlaceId = place.place_id;
      } else {
        this.destinationPlaceId = place.place_id;
      }
      const marker = new googleMap.maps.Marker({
        map: googleMap,
        anchorPoint: new googleMap.maps.Point(0, -29),
      });

      this.map.setCenter(place.geometry.location);
      this.map.setZoom(15);
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);



      this.route();
    });
  }

  checkIfPointOnRoute(start_lat, start_lng, end_lat, end_lng) {
    // var cascadiaFault = new googleMap.maps.Polyline({
    //             path: [
    //               new googleMap.maps.LatLng(start_lat, start_lng),
    //               new googleMap.maps.LatLng(end_lat, end_lng),
    //             ]
    //           });

    //             var latLng = new googleMap.maps.LatLng(31.426070, 34.582280)

    //         //  cascadiaFault.setMap(this.map);

    //            alert(googleMap.maps.geometry.poly.containsLocation(latLng, cascadiaFault));

    // if (googleMap.maps.geometry.poly.isLocationOnEdge({lat:31.66341, lng:34.55454}, cascadiaFault, 10e-1)) {
    //   alert('Route blocked')
    // }else{
    //   return false;
    // }
    return true;
  }

  route() {
    if (!this.originPlaceId || !this.destinationPlaceId) {
      return;
    }

    const me = this;

    this.directionsService.route(
      {
        origin: { placeId: this.originPlaceId },
        destination: { placeId: this.destinationPlaceId },
        travelMode: this.travelMode,
        provideRouteAlternatives: true
      },
      (response, status) => {
        if (status === "OK") {
          //console.log('response',response);
          var c = ['blue', 'gray', 'green'];
          response.routes.map((object, i) => {
            var directionsRenderer = new googleMap.maps.DirectionsRenderer({
              directions: response,
              routeIndex: i,
              map: this.map,
              polylineOptions: {
                strokeColor: c[i],
                path: [31.66341, 34.55454]
              }
            });

            // var chk = this.checkIfPointOnRoute(object.legs[0].start_location.lat(), object.legs[0].start_location.lng(), object.legs[0].end_location.lat(), object.legs[0].end_location.lng());
            // //alert(chk);
            // if(chk){
            //      const marker = new googleMap.maps.Marker({
            //         map:googleMap,
            //         anchorPoint: new googleMap.maps.Point(0, -29),
            //       });

            //      var myLatlng = new google.maps.LatLng(31.426070,34.582280);
            //       marker.setPosition(myLatlng);
            //       marker.setVisible(true);
            // }
          })
          //me.directionsRenderer.setDirections(response);
        } else {
          window.alert("Directions request failed due to " + status);
        }
      }
    );
  }
}
